import { HostAuthenticationTokenSource } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";

export function hostAuthenticationTokenSourceLabel(source: HostAuthenticationTokenSource): string {
    let text = "Unknown";
    switch (source) {
        case HostAuthenticationTokenSource.OAUTH:
            text = "OAuth";
            break;
        case HostAuthenticationTokenSource.PAT:
            text = "Personal Access Token";
            break;
    }
    return text;
}
